import { render, staticRenderFns } from "./CustomerDetailClassCard.vue?vue&type=template&id=6832232b&scoped=true&"
import script from "./CustomerDetailClassCard.vue?vue&type=script&lang=ts&"
export * from "./CustomerDetailClassCard.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerDetailClassCard.vue?vue&type=style&index=0&id=6832232b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6832232b",
  null
  
)

export default component.exports